import {
  EventConnectionOrder,
  EventConnectionSortDirection,
} from "@/pages/__generated__/ActivityScaffoldQuery.graphql";
import { defineMessages, IntlShape, MessageDescriptor } from "react-intl";
import { defineEnum } from "./enum";

type EnumKey = "PRIORITY" | "NEWEST" | "OLDEST";

type EventOrderDefinition = Readonly<
  Record<
    /// the enum key
    EnumKey,
    {
      /// the order uses by the backend;
      readonly order: EventConnectionOrder;
      /// the direction uses by the backend;
      readonly direction: EventConnectionSortDirection;
    }
  >
>;

export const EVENT_ORDER = defineEnum({
  PRIORITY: {
    order: "ORDERING_PRIORITY",
    direction: "DESCENDING",
  },
  NEWEST: { order: "CREATED_AT", direction: "DESCENDING" },
  OLDEST: { order: "CREATED_AT", direction: "ASCENDING" },
} as const satisfies EventOrderDefinition);

export type EventOrderKey = (typeof EVENT_ORDER.keys)[number];

const MESSAGES = defineMessages({
  priority: { defaultMessage: "Priority" },
  newest: { defaultMessage: "Newest" },
  oldest: { defaultMessage: "Oldest" },
}) as Record<EventOrderKey, MessageDescriptor>;

export const formatEventOrder = (intl: IntlShape, key: EventOrderKey) =>
  intl.formatMessage(MESSAGES[key]);
